import { SortDirectionToggler } from './SortDirectionToggler';
export const components = {
  SortDirectionToggler
};
flarum.reg.add('blomstra-sort-order-toggle', 'forum/components', null);